/* @flow */
import React from 'react';

import EventTracking, { getEventScreenName, getEventElementName, getEventContextName, getEventProperties } from 'lib/EventTracking';

const EventTrackingMixin = {
  propTypes: {
    eventElementName: React.PropTypes.string,
    eventContextName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
  },

  contextTypes: {
    eventScreenName: React.PropTypes.string,
    eventProperties: React.PropTypes.object,
    eventContextName: React.PropTypes.string,
    router: React.PropTypes.object,
  },

  trackClick() {
    const elementName = getEventElementName(this.props);
    const screenName = getEventScreenName(this.props, this.context.router);
    if (elementName && screenName) {
      EventTracking.tap(
        screenName,
        elementName,
        getEventContextName(this.props, this.context),
        getEventProperties(this.props.eventProperties, this.context)
      );
    }
  },
};

export default EventTrackingMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/EventTrackingMixin.js